<template>
  <tbody class="even:bg-gray-100 border-b">
    <tr>
      <td class="text-sm text-center align-text-top pt-2 px-4">
        {{ lineNumber }}
      </td>
      <td class="py-2 pr-8 align-text-top">
        <h2 class="text-sm text-blue-600">
          {{ offerLine.description }}
        </h2>
        <p v-if="offerLine.supplementaryDescription" class="text-gray-600 text-xs measure">
          {{ offerLine.supplementaryDescription }}
        </p>
      </td>
      <td class="py-2 pr-4 text-right align-text-top tabular-nums">{{ price }} &euro;</td>
    </tr>
    <tr>
      <td />
      <td class="pb-2 pr-4" colspan="2">
        <table class="table-auto w-full border-collapse">
          <tbody>
            <SubOfferLine
              v-for="(child, idx) in includedDirectChildren"
              :key="`included_direct_${idx}`"
              :offer-line="child"
            />
            <SubOfferLine
              v-for="(child, idx) in chargedExtraDirectChildren"
              :key="`extra_charged_direct_${idx}`"
              :offer-line="child"
            />
            <SubOfferLine
              v-for="(child, idx) in chargedExtraIndirectChildren"
              :key="`extra_charged_indirect_${idx}`"
              :offer-line="child"
            />
            <!-- <tr>
              <td>
                <h3 class="text-sm text-gray-800">
                  Lead capture landing page
                </h3>
              </td>
              <td class="text-right tabular-nums">
                <span class="text-sm text-gray-800 uppercase tracking-wider">Included</span>
              </td>
            </tr>
            <tr>
              <td>
                <h3 class="text-sm text-gray-800">
                  Facebook - Instagram Ads Creatives
                </h3>
              </td>
              <td class="text-right tabular-nums">
                <span class="text-sm text-gray-800 uppercase tracking-wider">Included</span>
              </td>
            </tr>
            <tr>
              <td>
                <h3 class="text-sm text-gray-800">
                  Πρόσβαση σε Cloud Service
                </h3>
              </td>
              <td class="text-right tabular-nums">
                <span class="text-sm text-gray-800 uppercase tracking-wider">Included</span>
              </td>
            </tr>
            <tr>
              <td>
                <h3 class="text-sm text-gray-800">
                  Remarketing Facebook - Instagram
                </h3>
              </td>
              <td class="text-sm text-right tabular-nums">
                15,00 &euro;
              </td>
            </tr>
            <tr>
              <td>
                <h3 class="text-sm text-gray-800">
                  Video Facebook Creative
                </h3>
              </td>
              <td class="text-sm text-right tabular-nums">
                45,00 &euro;
              </td>
            </tr> -->
          </tbody>
        </table>
      </td>
    </tr>
  </tbody>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import SubOfferLine from './SubOfferLine.vue';

export default {
  components: {
    SubOfferLine,
  },
  props: {
    lineNumber: {
      type: Number,
      default: 1,
    },
    offerLine: {
      type: Object,
      required: true,
    },
    offerLines: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    product() {
      if (typeof this.offerLine.productId !== 'string') {
        return null;
      }

      return this.$store.state.entities.products.byId[this.offerLine.productId];
    },
    price() {
      return this.offerLine.pricePerUnit * this.offerLine.quantity;
    },
    directChildren() {
      return this.offerLines.filter((offerLine) => {
        if ('uuid' in this.offerLine) {
          return offerLine.parentOfferLineId === this.offerLine.uuid;
        }

        return offerLine._parentOfferLineId === this.offerLine._uuid;
      });
    },
    includedDirectChildren() {
      return this.directChildren.filter((offerLine) => offerLine.pricePerUnit === 0);
    },
    chargedExtraDirectChildren() {
      return this.directChildren.filter((offerLine) => offerLine.pricePerUnit !== 0);
    },
    indirectChildren() {
      return this.offerLines.filter(this.isIndirectChild);
    },
    includedIndirectChildren() {
      return this.indirectChildren.filter((offerLine) => offerLine.pricePerUnit === 0);
    },
    chargedExtraIndirectChildren() {
      return this.indirectChildren.filter((offerLine) => offerLine.pricePerUnit !== 0);
    },
  },
  methods: {
    isIndirectChild(offerLine) {
      if (
        this.directChildren.some((directOfferLine) =>
          this.isDirectChildOfOfferLine(offerLine, directOfferLine)
        )
      ) {
        return true;
      }

      const parentOfferLine = this.offerLines.find((o) =>
        this.isDirectChildOfOfferLine(offerLine, o)
      );

      if (typeof parentOfferLine === 'undefined') {
        return false;
      }

      return this.isIndirectChild(parentOfferLine);
    },
    isDirectChildOfOfferLine(offerLine, parentOfferLine) {
      if ('uuid' in parentOfferLine) {
        return offerLine.parentOfferLineId === parentOfferLine.uuid;
      }

      return offerLine._parentOfferLineId === parentOfferLine._uuid;
    },
  },
};
</script>
